/* eslint-disable vue/multi-word-component-names */

<template>
  <main class="notfound">
    <div class="speech-bubble">
      404
    </div>
    <img
      src="../assets/site-icons/logo-white-404-2.svg"
      alt="current logo of a flower with petals missing which has drooped due to there being a 404 page not found - see what I did there :)"
      class="notfound__main-img"
    />
    <img
      src="../assets/site-icons/petal_1-icon.svg"
      alt="a light red petal shape from the flower of the logo"
      class="notfound__petal-1"
    />
    <h1 class="notfound__heading">
      looks like something did an uh-oh and drooped.
    </h1>
    <h2 class="notfound__subheading">
      we all have that problem from time to time...
    </h2>
    <h3 class="notfound__copy">
      Go back home and try again.
      <a href="/" class="notfound__link">
        <img
          src="../assets/site-icons/rightarrow-icon.svg"
          alt="red right arrow to go back home"
          class="notfound__link-img"
        />
      </a>
    </h3>

    <img
      src="../assets/site-icons/petal_2-icon.svg"
      alt="a light red petal shape from the flower of the logo"
      class="notfound__petal-2"
    />
  </main>
</template>

<script type="text/javascript">
export default {
  title: "mjccreative | 404"
};
</script>

<style lang="scss" scoped>
.notfound {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  &__main-img {
    width: 50%;
    height: auto;
    align-self: center;
    margin-top: 30px;
    margin-bottom: 30px;
    @media only screen and (min-width: 850px) {
      width: 30%;
    }
    @media only screen and (min-width: 1000px) {
      width: 25%;
    }
  }
  &__petal-1 {
    width: 30%;
    margin: auto;
    margin-right: 60%;
    margin-bottom: -2%;
    @media only screen and (min-width: 850px) {
      width: 15%;
    }
    @media only screen and (min-width: 850px) {
      width: 12%;
    }
  }
  &__petal-2 {
    width: 30%;
    margin: auto;
    margin-left: 60%;
    @media only screen and (min-width: 850px) {
      width: 15%;
    }
    @media only screen and (min-width: 850px) {
      width: 12%;
    }
  }
  &__heading {
    text-align: center;
  }
  &__subheading {
    text-align: center;
  }
  &__copy {
    text-align: center;
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__link {
    height: 20px;
  }
  &__link-img {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }
}
</style>
